var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProblemSolving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1362",
    "data-name": "Rectangle 1362",
    width: 32,
    height: 18,
    transform: "translate(-0.456 -0.104)",
    fill: "#fff",
    opacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7711",
    "data-name": "Group 7711",
    transform: "translate(-1055 -1189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 32,
    height: 32,
    rx: 10,
    transform: "translate(1055 1189)",
    fill: "#3e7cf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "technical-support-svgrepo-com",
    transform: "translate(1000.178 1196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M62.341,13.561a.958.958,0,0,0,1.887-.231c0-4.267.2-4.665-.367-5.128C65.169.143,76.433.2,77.8,8.2c-.57.465-.366.861-.366,5.127a.949.949,0,0,0,.437.787c0,3.319-1.346,3.125-5.4,4.2a1,1,0,1,0,.22.942c3.269-.867,6.142-1.14,6.142-4.407v-.67a.951.951,0,0,0,.483-.619,2.426,2.426,0,0,0,0-4.85.944.944,0,0,0-.451-.6A7.292,7.292,0,0,0,78.2,4.649C74.346-3.306,62.96-.193,62.782,7.516a2.823,2.823,0,0,0,.01.6.944.944,0,0,0-.451.6,2.425,2.425,0,0,0,0,4.85Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemSolving);
export default __webpack_public_path__ + "static/media/problem-solving.fa7e7eda0b6de12331c7cdea6add6c09.svg";
export { ForwardRef as ReactComponent };